$(() => {
  const container = $(".topbnr--container:not(.topbnr--container_hidden)")
  if (container.length < 1) {
    return
  }

  const doc = $(document)
  const fixedPos = container.offset().top + container.outerHeight()

  doc.on("fixer", () => {
    const isFixed = window.pageYOffset > fixedPos
    window.HB.Memo.toggleClass(container, "topbnr--container_hidden", isFixed)
  })
})
